import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useState, useRef } from "react";

const cardStyles = {
  imagen: {
    margin: "auto",
    width: "40%",
  },
};

const Login = ({
  colorMode,
  isNewThemeLoaded,
  onNewThemeChange,
  location,
  onLogin,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const recaptchaRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmitV2 = (e) => {
    e.preventDefault();
    if (!captchaValue) {
      alert("Por favor complete el CAPTCHA.");
      return;
    }
    onLogin(email, password);
  };

  /*const handleSubmitV2Insignia = async (e) => {
    e.preventDefault();
    if (e.nativeEvent.submitter.name === "loginButton") {
      try {
        const captchaToken = await recaptchaRef.current.executeAsync();
        if (!captchaToken) {
          alert("Por favor complete la verificación de seguridad.");
          return;
        }
        setCaptchaValue(captchaToken);
        onLogin(email, password);
      } catch (error) {
        console.error("Error en reCAPTCHA:", error);
        alert("Error en la verificación de seguridad. Por favor intente nuevamente.");
      }
    }
  };*/

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <form onSubmit={handleSubmitV2}> 
    {/* <form onSubmit={handleSubmitV2Insignia}>*/}
      <div
        className="pages-body login-page flex flex-column"
        style={{ background: "none", backgroundColor: "#0150a0" }} 
      >
        <div className="align-self-center mt-auto mb-auto">
          <div className="pages-panel card flex flex-column">
            <h1 className="pages-detail">Administración</h1>
            <img
              src="assets/layout/images/Recurso-2.png"
              alt=""
              style={cardStyles.imagen}
            />

            <h5 className="pages-detail mb-6 px-6">
              Bienvenido, inicia sesión para continuar
            </h5>

            <div className="input-panel flex flex-column px-3">
              <div className="p-inputgroup">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-envelope"></i>
                </span>
                <span className="p-float-label">
                  <InputText
                    autoComplete="on"
                    type="text"
                    id="inputgroup1"
                    value={email}
                    onChange={handleEmailChange}
                  />
                  <label htmlFor="inputgroup1">Correo Electrónico</label>
                </span>
              </div>

              <div className="p-inputgroup mt-4 mb-6">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-lock"></i>
                </span>
                <span className="p-float-label">
                  <InputText
                    autoComplete="off"
                    type={showPassword ? "text" : "password"}
                    id="inputgroup2"
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  <label htmlFor="inputgroup2">Contraseña</label>
                </span>
                <span className="p-inputgroup-addon" style={{ cursor: 'pointer' }} onClick={toggleShowPassword}>
                  <i className={showPassword ? "pi pi-eye-slash" : "pi pi-eye"}></i>
                </span>
              </div>

              {/* ReCAPTCHA antiguo*/}
              <div
                className="p-inputgroup mt-3 mb-6"
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ReCAPTCHA 
                  sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" 
                  onChange={handleCaptchaChange}
                />
              </div>
              
              {/*<ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                onChange={handleCaptchaChange}
              />*/}
            </div>
            <Button
              type="submit"
              name="loginButton"
              className="login-button mb-3 px-3"
              label="Ingresar"
              style={{ backgroundColor: "#0150a0" }}
            ></Button>
            {/* <Button
              className="login-button mb-4 px-3"
              label="Registrarme"
              style={{
                backgroundColor: "white",
                color: "#0150a0",
                borderColor: "#20ba84",
                border: "1px solid #20ba84",
              }}
            ></Button> */}
            {/* <Button
              className="login-button mb-3 px-3"
              label="Recuperar Contraseña"
              style={{
                backgroundColor: "white",
                color: "#6c757d",
                fontSize: "13px",
              }}
              onClick={() => {}}
            ></Button> */}
          </div>
        </div>
      </div>
    </form>
  );
};

export default Login;
